import { connect } from "react-redux";

import { getItems, genSaveItemsFunct } from "lib/stateHelpers";

const mapStateToProps = state => ({ complaints: getItems(state, "navigation.complaints") });

const mapDispatchToProps = dispatch => ({
  saveComplaints: genSaveItemsFunct(dispatch, "navigation.complaints")
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
